import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import { withRouter } from 'react-router-dom';
import { useWindowSize } from 'react-use';
import { RemoveScroll } from 'react-remove-scroll';
import useOnEsc from 'hooks/useOnEsc';
import useTrapFocus from 'hooks/useTrapFocus';
import useRandomId from 'hooks/useRandomId';
import useFocusOnOpen from 'hooks/useFocusOnOpen';
import VisuallyHidden from 'components/consumer/VisuallyHidden';
import getOrCreateElementById from 'commons/getOrCreateElementById';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
import useScreen from 'hooks/useScreen';
import MobileModalCloseIcon from './MobileModalCloseIcon';
import MobileModalContentUnderHeader from './MobileModalContentUnderHeader';
const mobileModalRootElement = getOrCreateElementById('MobileModal-root');
const MobileModal = t0 => {
  const $ = _c(102);
  const {
    backgroundColor: t1,
    children,
    className: t2,
    closeIcon: t3,
    contentNoPadding: t4,
    contentUnderHeader: t5,
    enableHashHistory: t6,
    headerCenter,
    headerNoPointerEvents: t7,
    headerRight,
    headerRightClassName: t8,
    hideHeader: t9,
    history,
    isFullHeight: t10,
    isMaterialSwatch: t11,
    isOpen: t12,
    location: t13,
    lockScrollWhenOpen: t14,
    modalPath: t15,
    noPadding: t16,
    noStickyFooterPadding: t17,
    onClose,
    stickyFooter,
    title,
    variant
  } = t0;
  const backgroundColor = t1 === undefined ? "white" : t1;
  const className = t2 === undefined ? "" : t2;
  const closeIcon = t3 === undefined ? "close" : t3;
  const contentNoPadding = t4 === undefined ? false : t4;
  const contentUnderHeader = t5 === undefined ? null : t5;
  const enableHashHistory = t6 === undefined ? true : t6;
  const headerNoPointerEvents = t7 === undefined ? false : t7;
  const headerRightClassName = t8 === undefined ? "" : t8;
  const hideHeader = t9 === undefined ? false : t9;
  const isFullHeight = t10 === undefined ? false : t10;
  const isMaterialSwatch = t11 === undefined ? false : t11;
  const isOpen = t12 === undefined ? false : t12;
  let t18;
  if ($[0] !== t13) {
    t18 = t13 === undefined ? {} : t13;
    $[0] = t13;
    $[1] = t18;
  } else {
    t18 = $[1];
  }
  const location = t18;
  const lockScrollWhenOpen = t14 === undefined ? true : t14;
  const modalPath = t15 === undefined ? "modal" : t15;
  const noPadding = t16 === undefined ? false : t16;
  const noStickyFooterPadding = t17 === undefined ? false : t17;
  const {
    isMobile
  } = useScreen();
  const modalRef = useFocusOnOpen(isOpen);
  const modalTitleId = useRandomId("MobileModal-title");
  useTrapFocus(isOpen, modalRef);
  const [isHistoryPushed, setIsHistoryPushed] = useState(false);
  let t19;
  if ($[2] !== location.state) {
    t19 = JSON.stringify(location.state);
    $[2] = location.state;
    $[3] = t19;
  } else {
    t19 = $[3];
  }
  const locationStateString = t19;
  let t20;
  let t21;
  if ($[4] !== enableHashHistory || $[5] !== history || $[6] !== isHistoryPushed || $[7] !== isMobile || $[8] !== onClose) {
    t20 = () => {
      if (isMobile && enableHashHistory && history && isHistoryPushed) {
        const unlisten = history.listen(() => {
          if (history.action === "POP") {
            onClose();
          }
        });
        return unlisten;
      }
    };
    t21 = [isMobile, enableHashHistory, history, isHistoryPushed, onClose];
    $[4] = enableHashHistory;
    $[5] = history;
    $[6] = isHistoryPushed;
    $[7] = isMobile;
    $[8] = onClose;
    $[9] = t20;
    $[10] = t21;
  } else {
    t20 = $[9];
    t21 = $[10];
  }
  useEffect(t20, t21);
  let t22;
  let t23;
  if ($[11] !== enableHashHistory || $[12] !== history || $[13] !== isHistoryPushed || $[14] !== isMobile || $[15] !== isOpen || $[16] !== locationStateString || $[17] !== modalPath) {
    t22 = () => {
      if (isMobile && enableHashHistory && history && !isHistoryPushed && isOpen && history?.location?.hash !== modalPath) {
        const locationState = JSON.parse(locationStateString || "{}");
        history.push(history?.location?.search ? `${history.location.search}#${modalPath}` : `#${modalPath}`, locationState);
        setIsHistoryPushed(true);
      }
    };
    t23 = [isMobile, isOpen, enableHashHistory, history, isHistoryPushed, modalPath, locationStateString];
    $[11] = enableHashHistory;
    $[12] = history;
    $[13] = isHistoryPushed;
    $[14] = isMobile;
    $[15] = isOpen;
    $[16] = locationStateString;
    $[17] = modalPath;
    $[18] = t22;
    $[19] = t23;
  } else {
    t22 = $[18];
    t23 = $[19];
  }
  useEffect(t22, t23);
  let t24;
  let t25;
  if ($[20] !== isOpen) {
    t24 = () => {
      if (!isOpen) {
        setIsHistoryPushed(false);
      }
    };
    t25 = [isOpen];
    $[20] = isOpen;
    $[21] = t24;
    $[22] = t25;
  } else {
    t24 = $[21];
    t25 = $[22];
  }
  useEffect(t24, t25);
  const {
    height
  } = useWindowSize(800, 360);
  const [hasScrolledDown, setHasScrolledDown] = useState(false);
  let t26;
  if ($[23] !== enableHashHistory || $[24] !== history || $[25] !== isHistoryPushed || $[26] !== isMobile || $[27] !== onClose) {
    t26 = () => {
      if (isMobile && enableHashHistory && history && isHistoryPushed) {
        history.goBack();
      }
      onClose();
    };
    $[23] = enableHashHistory;
    $[24] = history;
    $[25] = isHistoryPushed;
    $[26] = isMobile;
    $[27] = onClose;
    $[28] = t26;
  } else {
    t26 = $[28];
  }
  const onCloseClick = t26;
  useOnEsc(isOpen, onCloseClick);
  if (!isOpen) {
    return null;
  }
  const t27 = `lg:hidden flex flex-col fixed z-[2000] h-screen left-0 top-0 w-screen ${className}`;
  let t28;
  if ($[29] !== isFullHeight || $[30] !== t27) {
    t28 = classNames(t27, {
      "bg-white": isFullHeight
    });
    $[29] = isFullHeight;
    $[30] = t27;
    $[31] = t28;
  } else {
    t28 = $[31];
  }
  let t29;
  if ($[32] !== height) {
    t29 = height ? {
      height
    } : undefined;
    $[32] = height;
    $[33] = t29;
  } else {
    t29 = $[33];
  }
  let t30;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <VisuallyHidden>Modal dialog content starts</VisuallyHidden>;
    $[34] = t30;
  } else {
    t30 = $[34];
  }
  let t31;
  if ($[35] !== isFullHeight || $[36] !== onCloseClick) {
    t31 = !isFullHeight && <div aria-hidden={true} className={classNames("bg-[rgba(0,0,0,.3)] h-screen left-0 absolute top-0 w-screen", {
      hidden: isFullHeight
    })} onClick={onCloseClick} tabIndex="-1" />;
    $[35] = isFullHeight;
    $[36] = onCloseClick;
    $[37] = t31;
  } else {
    t31 = $[37];
  }
  let t32;
  if ($[38] !== backgroundColor || $[39] !== closeIcon || $[40] !== contentUnderHeader || $[41] !== hasScrolledDown || $[42] !== headerCenter || $[43] !== headerNoPointerEvents || $[44] !== headerRight || $[45] !== headerRightClassName || $[46] !== hideHeader || $[47] !== isMaterialSwatch || $[48] !== onCloseClick || $[49] !== variant) {
    t32 = !hideHeader && <div className={classNames("flex h-14 p-4 items-center", {
      "pointer-events-none invisible": headerNoPointerEvents,
      "pt-4 pr-4 pb-4 pl-10": isMaterialSwatch,
      "!z-[4003]": variant === "GridWithSidebar",
      "bg-white": backgroundColor !== "green" && !isMaterialSwatch,
      "bg-brand-dark": backgroundColor === "green",
      "!bg-transparent": variant === "ModularAddProducts",
      relative: !contentUnderHeader,
      "!bg-transparent absolute w-screen z-[11]": contentUnderHeader,
      "after:[content:\"\"] after:[background-image:linear-gradient(0deg,hsla(0,0%,93.3%,0)_,rgba(0,0,0,.3))] after:top-0 after:left-0 after:bottom-0 after:right-0 after:absolute after:[transition:opacity_.2s_ease-in-out] after:z-[-1]": contentUnderHeader,
      "after:opacity-100": contentUnderHeader && !hasScrolledDown,
      "!bg-white after:opacity-0": contentUnderHeader && hasScrolledDown && !isMaterialSwatch,
      "flex-row-reverse": closeIcon === "arrow"
    })}><div className={classNames(`z-[1] ${headerRightClassName}`, {
        "[transition:opacity_.2s_ease-in-out]": contentUnderHeader,
        "opacity-0 pointer-events-none": contentUnderHeader && !hasScrolledDown,
        "opacity-100 pointer-events-auto": contentUnderHeader && hasScrolledDown
      })}>{headerRight}</div><div className={classNames("h-full text-center flex-1 z-0", {
        "pointer-events-none cursor-default [transition:opacity_.2s_ease-in-out]": contentUnderHeader,
        "opacity-0": contentUnderHeader && !hasScrolledDown,
        "opacity-100": contentUnderHeader && hasScrolledDown
      })}>{headerCenter}</div><span className="items-center cursor-pointer flex h-14 w-14 justify-end z-10" role="button" tabIndex="0" onClick={onCloseClick}><MobileModalCloseIcon icon={closeIcon} color={closeIcon === "close-white" || contentUnderHeader && !hasScrolledDown ? "white" : "content"} variant={variant} /></span></div>;
    $[38] = backgroundColor;
    $[39] = closeIcon;
    $[40] = contentUnderHeader;
    $[41] = hasScrolledDown;
    $[42] = headerCenter;
    $[43] = headerNoPointerEvents;
    $[44] = headerRight;
    $[45] = headerRightClassName;
    $[46] = hideHeader;
    $[47] = isMaterialSwatch;
    $[48] = onCloseClick;
    $[49] = variant;
    $[50] = t32;
  } else {
    t32 = $[50];
  }
  let t33;
  if ($[51] !== backgroundColor || $[52] !== contentUnderHeader || $[53] !== hasScrolledDown || $[54] !== headerRight || $[55] !== headerRightClassName || $[56] !== isMaterialSwatch || $[57] !== onCloseClick || $[58] !== variant) {
    t33 = isMaterialSwatch && !hasScrolledDown && <div className={classNames("justify-end flex h-14 pt-4 pr-4 pb-4 pl-6", {
      "!z-[4003]": variant === "GridWithSidebar",
      "!bg-transparent": variant === "ModularAddProducts",
      "bg-white": backgroundColor !== "green" && !isMaterialSwatch,
      "bg-brand-dark": backgroundColor === "green",
      relative: !contentUnderHeader,
      "bg-transparent absolute w-screen z-[11]": contentUnderHeader,
      "after:[content:\"\"] after:[background-image:linear-gradient(0deg,hsla(0,0%,93.3%,0)_,rgba(0,0,0,.3))] after:top-0 after:left-0 after:bottom-0 after:right-0 after:absolute after:[transition:opacity_.2s_ease-in-out] after:z-[-1]": contentUnderHeader,
      "after:opacity-100": contentUnderHeader && !hasScrolledDown,
      "bg-white after:opacity-0": contentUnderHeader && hasScrolledDown && !isMaterialSwatch
    })} onClick={onCloseClick} role="presentation"><div className={classNames(`z-[1] ${headerRightClassName}`, {
        "[transition:opacity_.2s_ease-in-out]": contentUnderHeader,
        "opacity-0 pointer-events-none": contentUnderHeader && !hasScrolledDown,
        "opacity-100 pointer-events-auto": contentUnderHeader && hasScrolledDown
      })}>{headerRight}</div></div>;
    $[51] = backgroundColor;
    $[52] = contentUnderHeader;
    $[53] = hasScrolledDown;
    $[54] = headerRight;
    $[55] = headerRightClassName;
    $[56] = isMaterialSwatch;
    $[57] = onCloseClick;
    $[58] = variant;
    $[59] = t33;
  } else {
    t33 = $[59];
  }
  const t34 = variant === "ModularAddProducts";
  const t35 = backgroundColor === "white";
  const t36 = backgroundColor === "green";
  const t37 = !noPadding;
  let t38;
  if ($[60] !== contentNoPadding || $[61] !== contentUnderHeader || $[62] !== isFullHeight || $[63] !== t34 || $[64] !== t35 || $[65] !== t36 || $[66] !== t37) {
    t38 = classNames("relative rounded-bl-lg rounded-br-lg overflow-y-auto overflow-x-hidden pt-0 pb-[42px]", {
      "!p-0": contentNoPadding,
      "!bg-transparent [&_img]:w-4/5 [&_img]:m-[10%]": t34,
      "bg-white": t35,
      "bg-brand-dark": t36,
      "rounded-bl-none rounded-br-none flex-1": isFullHeight,
      "px-4": t37,
      "max-h-screen": contentUnderHeader
    });
    $[60] = contentNoPadding;
    $[61] = contentUnderHeader;
    $[62] = isFullHeight;
    $[63] = t34;
    $[64] = t35;
    $[65] = t36;
    $[66] = t37;
    $[67] = t38;
  } else {
    t38 = $[67];
  }
  let t39;
  if ($[68] !== contentUnderHeader || $[69] !== isMaterialSwatch || $[70] !== noPadding) {
    t39 = !!contentUnderHeader && <div className={classNames({
      "ml-[-.5%] mr-0": !noPadding
    })}><MobileModalContentUnderHeader onIntersectionChange={isIntersecting => {
        if (!isMaterialSwatch) {
          setHasScrolledDown(!isIntersecting);
        }
      }}>{contentUnderHeader}</MobileModalContentUnderHeader></div>;
    $[68] = contentUnderHeader;
    $[69] = isMaterialSwatch;
    $[70] = noPadding;
    $[71] = t39;
  } else {
    t39 = $[71];
  }
  let t40;
  if ($[72] !== modalTitleId || $[73] !== title) {
    t40 = title && <h2 className="text-xl font-bold text-gray m-0 pt-[5px] px-0 pb-2" id={modalTitleId}>{title}</h2>;
    $[72] = modalTitleId;
    $[73] = title;
    $[74] = t40;
  } else {
    t40 = $[74];
  }
  let t41;
  if ($[75] !== children || $[76] !== t38 || $[77] !== t39 || $[78] !== t40) {
    t41 = <div className={t38} id="MobileModal-content">{t39}{t40}{children}</div>;
    $[75] = children;
    $[76] = t38;
    $[77] = t39;
    $[78] = t40;
    $[79] = t41;
  } else {
    t41 = $[79];
  }
  const t42 = !stickyFooter;
  const t43 = !!stickyFooter;
  const t44 = !!stickyFooter;
  const t45 = !!stickyFooter && !noStickyFooterPadding;
  let t46;
  if ($[80] !== t42 || $[81] !== t43 || $[82] !== t44 || $[83] !== t45) {
    t46 = classNames({
      hidden: t42,
      "bg-white [border-top:1px_solid_#f1f1f1]": t43,
      "supports-[padding:max(0px)]:pb-[max(11px,_env(safe-area-inset-bottom))]": t44,
      "px-4 py-[11px] pb-0": t45
    });
    $[80] = t42;
    $[81] = t43;
    $[82] = t44;
    $[83] = t45;
    $[84] = t46;
  } else {
    t46 = $[84];
  }
  let t47;
  if ($[85] !== stickyFooter || $[86] !== t46) {
    t47 = <div className={t46}>{stickyFooter}</div>;
    $[85] = stickyFooter;
    $[86] = t46;
    $[87] = t47;
  } else {
    t47 = $[87];
  }
  let t48;
  if ($[88] === Symbol.for("react.memo_cache_sentinel")) {
    t48 = <VisuallyHidden>Modal dialog content ends</VisuallyHidden>;
    $[88] = t48;
  } else {
    t48 = $[88];
  }
  let t49;
  if ($[89] !== modalRef || $[90] !== modalTitleId || $[91] !== t28 || $[92] !== t29 || $[93] !== t31 || $[94] !== t32 || $[95] !== t33 || $[96] !== t41 || $[97] !== t47) {
    t49 = <div className={t28} style={t29} ref={modalRef} role="dialog" aria-labelledby={modalTitleId}>{t30}{t31}{t32}{t33}{t41}{t47}{t48}</div>;
    $[89] = modalRef;
    $[90] = modalTitleId;
    $[91] = t28;
    $[92] = t29;
    $[93] = t31;
    $[94] = t32;
    $[95] = t33;
    $[96] = t41;
    $[97] = t47;
    $[98] = t49;
  } else {
    t49 = $[98];
  }
  let t50;
  if ($[99] !== lockScrollWhenOpen || $[100] !== t49) {
    t50 = createPortal(<RemoveScroll removeScrollBar={false} enabled={lockScrollWhenOpen}>{t49}</RemoveScroll>, mobileModalRootElement);
    $[99] = lockScrollWhenOpen;
    $[100] = t49;
    $[101] = t50;
  } else {
    t50 = $[101];
  }
  return t50;
};
MobileModal.propTypes = {
  backgroundColor: PropTypes.oneOf(['white', 'green']),
  children: PropTypes.node,
  className: PropTypes.string,
  closeIcon: PropTypes.oneOf(['close', 'arrow']),
  contentNoPadding: PropTypes.bool,
  contentUnderHeader: PropTypes.node,
  enableHashHistory: PropTypes.bool,
  headerCenter: PropTypes.node,
  headerNoPointerEvents: PropTypes.bool,
  headerRight: PropTypes.node,
  headerRightClassName: PropTypes.string,
  hideHeader: PropTypes.bool,
  history: PropTypes.object,
  isFullHeight: PropTypes.bool,
  isMaterialSwatch: PropTypes.bool,
  isOpen: PropTypes.bool,
  location: PropTypes.shape({}),
  lockScrollWhenOpen: PropTypes.bool,
  modalPath: PropTypes.string,
  noPadding: PropTypes.bool,
  noStickyFooterPadding: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  stickyFooter: PropTypes.node,
  title: PropTypes.string,
  variant: PropTypes.oneOf(['GridWithSidebar', 'ModularAddProducts'])
};
export default withBrowserOnly(withRouter(MobileModal));